import { turnSelectors, inboxSelectors } from '~/store';
// ---- internal imports ----


function getCheckpoint(state) {
	return state.checkpoint;
}

function getCheckpointState(state) {
	return getCheckpoint(state)?.state;
}

function hasCheckpoint(state) {
	return !!getCheckpointState(state)?.turn;
}

function getCheckpointDate(state) {
	return hasCheckpoint(state)
		? turnSelectors.getTurnDate(getCheckpointState(state))
		: 'None';
}

function getInboxLastMsgId(state) {
	return state.checkpoint?.inboxLastMsgId;
}

function getInboxUnreadMessagesIds(state) {
	return hasCheckpoint(state)
		? inboxSelectors.getUnreadMessagesIds(getCheckpointState(state))
		: [];
}

function getFetchNextTurnAfterReload(state) {
	return state.checkpoint.fetchNextTurnAfterReload ?? false;
}


export {
	getCheckpoint,
	getCheckpointDate,
	getInboxLastMsgId,
	getInboxUnreadMessagesIds,
	getFetchNextTurnAfterReload,
};
